import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getExtraNowImages, getShorturl } from '../../actions/extraNowImageActions'
import PostForm from '../posts/PostForm'
import { Card, Col } from "react-bootstrap";
import {
  marDiscountCode,
  marDiscountCodeMsg,
} from "../../settings/About/AboutUtils";
import { CopyToClip } from "../../utils/copy.utils";


const ExtraNowFeeds = () => {
  const dispatch = useDispatch()
  const extranowimages = useSelector((state) => state.extranowimage.extranowimages)
  const loadingExtraNowImg = useSelector((state) => state.extranowimage.loadingExtraNowImg)
  //console.log('extranowimages', extranowimages)
  const user = useSelector((state) => state.auth.user);
  const [isCopied, setIsCopied] = useState(false);
  const [copiedValue, setCopiedValue] = useState("")




  return (
    <>
      <PostForm />

      {/* 
         {extranowimages.map((item)=>(
             <Card border="info">
             {item.imgUrls[0] && (
               <Card.Img
                 style={{ height: "15rem", objectFit: "cover" }}
                 variant="top"
                 className="img-fluid"
                 alt="room_item.imgUrls[0]"
                 src={item.imgUrls[0] && item.imgUrls[0]}
               />
             )}
             {!item.imgUrls[0] && (
               <Card.Header>
                 <h4 className="mt-3 text-center text-info">
                   GET 15% DISCOUNT ON BOOKING FEES - SPOTAHOME WEBSITE
                 </h4>
                 <h1
                   className="lead text-center bg-info border text-white border-warning b-5 m-5 p-2 shadow"
                   style={{
                     verticalAlign: "middle",
                     textAlign: "center",
                     alignContent: "center",
                     fontSize: "50px",
                     fontWeight: "bold",
                   }}
                 >
                   {marDiscountCode}
                 </h1>
                 <p className="text-center">
                   <em>{marDiscountCodeMsg}</em>
                 </p>
               </Card.Header>
             )}
             <Card.Body>
               <Card.Title>
                 <span role="img" aria-label="">
                   📢
                 </span>
                 {""}
                 {item.title && item.title.toUpperCase()}
                 {item.checked === 'CHECKED' ? <span role="img" aria-label="">
                   ✅
                 </span> : <span role="img" aria-label="">
                   ☑️
                 </span>}
               </Card.Title>
               <Card.Text>
                 <span role="img" aria-label="">
                   🕘{""}
                 </span>{" "}
                 {item.available_from}{" "}
     
                 <span>
                   IAR-ref:{"   "}
                   <strong> {item.urlCode && item.urlCode}</strong>
                 </span>
               </Card.Text>
               <Card.Content>
                 <span role="img" aria-label="">
                   💶
                   {item.price}
                   {"/month"}
                 </span>{" "}
                 <span role="img" aria-label="">
                   🕘{""}
                 </span>{" "}
     
                 {item.chargeData}{" "}
                 <span role="img" aria-label="">
                   🚃{""}
                 </span>{" "}
     
                 {item.transportData}{" "}
                 <span role="img" aria-label="">
                   📍{""}
                 </span>{" "}
     
                 {item.address}{" "}
     
               </Card.Content>
               
               <Card.Footer>
                 <Card.Body>
                   <Card.Link
                     href={item.url && item.url}
                     target="_blank"
                     rel="noopener noreferrer"
                   >
                     {" "}
                     <span role="img" aria-label="">
                       🔗 👉{" "}
                     </span>
                     {item.url && item.url}
                   </Card.Link>
                   {item.imgUrls[0] && user.role === "admin" && (
                     <Card.Link href={item.imgUrls[0]} download>
                       download
                     </Card.Link>
                   )}
     
     
                   <CopyToClip
                     value={`
                             📢 ${item.title && item.title.toUpperCase()} - #${item.city && item.city.toLowerCase()}\n
                             🕘 ${item.available_from} ${item.checked === 'CHEKED' ? '✅' : '☑️'}\n
                                ${item.lastUpDate && item.lastUpDate} \n
                             💶 ${item.price} €/month\n
                                 ${item.charges ? item.charges : ''} /month\n
                             IAR-ref: ${item.urlCode && item.urlCode} \n 
                             🚃 ${item.transportData && item.transportData} \n 
                             📍 ${item.address && item.address} \n
                             🔗 👉 ${item.urllink && item.urllink}\n \n
                             📝 *We help you to find 🏠rooms, studios, apartments in majors Europeans cities... Check other properties in #paris, #brussels, #london, #berlin,#dublin, #barcelona, #madrid...* 
                             🔗 👉  https://bit.ly/36W88xX \n 
                             Use FBMARIUS15 to have 15% discount on reservation fees \n 
                             💬 🇬🇧🇫🇷`}
                     isCopied={isCopied}
                     onCopy={() => setIsCopied(true)}
                     onChange={(copiedValue) => {
                       setIsCopied(false);
                       setCopiedValue(copiedValue);
                     }}
                   />
                 </Card.Body>
               </Card.Footer>
             </Card.Body>
           </Card>
       
         ))} */}



    </>
  )
}

export default ExtraNowFeeds